import { render } from "./Total.vue?vue&type=template&id=4d240a4b"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"

import "./Total.vue?vue&type=style&index=0&id=4d240a4b&lang=scss"

import exportComponent from "/Users/christophermoss/Dropbox/Dock/grplus-co-uk/wp/wp-content/themes/scaffoldingsales/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__